import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { Spin } from 'antd';

import type { EUserRole } from '@/shared/consts';
import { ROUTES } from '@/shared/consts';
import { useUserProfile } from '@/shared/hooks';

interface IProps {
  permittedRoles: EUserRole[];
  urlToRedirect?: string;
}

export const RoleCheckGuard = ({
  permittedRoles,
  urlToRedirect = ROUTES.HOME,
  children,
}: PropsWithChildren<IProps>) => {
  const [isPermittedRole, setIsPermittedRole] = useState(false);

  const { userProfile } = useUserProfile();

  useEffect(() => {
    const userRole = userProfile.roles[0];

    if (permittedRoles.includes(userRole)) {
      setIsPermittedRole(true);
    } else {
      window.location.replace(urlToRedirect);
    }
  }, [userProfile]);

  if (isPermittedRole) {
    return children;
  }

  return (
    <Spin
      fullscreen
      size="large"
    />
  );
};
